export const dlg_annual_report = [
  {
    id: 1,
    name: 'dlg-annual-performance-plan_2024-25_english',
    summary: 'shortsummary/dlg-annual-performance-plan_2024-25_english.html',
    link: 'dlg-annual-performance-plan_2024-25_english.pdf',
    audio_en: 'audio/en/dlg-annual-performance-plan_2024-25_english_en.mp3',
    audio_af: 'audio/af/dlg-annual-performance-plan_2024-25_english_af.mp3',
    audio_xh: 'audio/xh/dlg-annual-performance-plan_2024-25_english_xh.mp3'
  }
];